import type { Workshop } from '../../../../api/workshops';
import { StatusPill } from '../../primitives';

import { paceToStatus, WorkshopStatusPill } from './workshopStatus';

/** Renders the Status column for one row. Active + future → pacing pill (Axis
 *  B); otherwise the lifecycle status pill (Axis A). */
export function WorkshopStatusCell({ w, now }: { w: Workshop; now: Date }) {
  const isActiveFuture =
    w.lifecycle === 'active' && new Date(w.startsAt).getTime() >= now.getTime();
  if (isActiveFuture) {
    const pace = paceToStatus(w.paceStatus);
    return <StatusPill tone={pace.tone} label={pace.label} />;
  }
  return <WorkshopStatusPill workshop={w} now={now} />;
}
